import ScrollToTop from "../../components/scrollToTop/scrollToTop";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import "./privacy.css";
import navBarEn from "../../translations/en/navbar.json";
import navBarEs from "../../translations/es/navbar.json";
import Helmet from "react-helmet";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";

function Privacy() {
  const [tPrivacy] = useTranslation("privacy");
  const [tSMetaData] = useTranslation("metaData");
  const navigate = useNavigate();
  const location = useLocation();
  const { us, es } = location.state || "";

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].privacy}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].privacy}`
  );

  const handleGoBack = () => {
    if (
      !sessionStorage.getItem("routeEn") ||
      !sessionStorage.getItem("routeEs") ||
      !localStorage.getItem("lng") ||
      !us ||
      !es
    ) {
      navigate("/");
    } else {
      if (localStorage.getItem("lng") === "us") {
        navigate(us);
      } else {
        navigate(es);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("avisoPrivacidad.title")}</title>
        <meta
          name="description"
          content={tSMetaData("avisoPrivacidad.description")}
        />
      </Helmet>
      <ScrollToTop />
      <Navbar />

      <div className="container-fluid backg-gray">
        <div className="row">
          <div className="col">
            {tPrivacy("privacidad.update")}
          </div>
        </div>
      </div>

      <div className="container p-0 ps-3 ps-sm-0 btn-back-container">
        <div className="row">
          <div className="col">
            <Link className="btn-cont-nat" to="/contracts">
              {tPrivacy("privacidad.button")}
            </Link>
          </div>
        </div>
      </div>

      <section className="container national-contract-container">
        <div className="row">
          <div className="col">
            <h1>{tPrivacy("privacidad.title_privacy")}</h1>
            <p>{tPrivacy("texto_privacy.ley")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.uno")}</p>
            <p >{tPrivacy("texto_privacy.pa_uno")} {tPrivacy("texto_privacy.pa_uno_uno")} {tPrivacy("texto_privacy.cargo")} {tPrivacy("texto_privacy.p")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.dos")}</p>
            <p>{tPrivacy("texto_privacy.pa_dos")}</p>
            <p>
              <ul>
                <li>{tPrivacy("texto_privacy.atender")}</li>
                <li>{tPrivacy("texto_privacy.datos")}</li>
              </ul>
            </p>
            <p>{tPrivacy("texto_privacy.todo")} <a href="mailto:cadatospersonales@aeromexico.com">cadatospersonales@aeromexico.com</a>.</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.tres")}</p>
            <p >{tPrivacy("texto_privacy.pa_tres")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.tresuno")}</p>
            <p >{tPrivacy("texto_privacy.pa_tres_uno")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.tresdos")}</p>
            <p >{tPrivacy("texto_privacy.pa_tres_dos")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.cuatro")}</p>
            <p >{tPrivacy("texto_privacy.pa_cuatro")}</p>

            <p className="mb-0"><span className="fw-bold">{tPrivacy("texto_privacy.inc_a")}</span> {tPrivacy("texto_privacy.parr_inc_a")}</p>
            <p>
              <ul>
                <li>{tPrivacy("texto_privacy.contactarlo")}</li>
                <li>{tPrivacy("texto_privacy.info")}</li>
                <li>{tPrivacy("texto_privacy.contrato")}</li>
                <li>{tPrivacy("texto_privacy.especial")}</li>
                <li>{tPrivacy("texto_privacy.registro")}</li>
                <li>{tPrivacy("texto_privacy.reembolsos")}</li>
                <li>{tPrivacy("texto_privacy.alguna")}</li>
                <li>{tPrivacy("texto_privacy.aplicable")}</li>
                <li>{tPrivacy("texto_privacy.elaboracion")}</li>
                <li>{tPrivacy("texto_privacy.obligaciones")}</li>
                <li>{tPrivacy("texto_privacy.envio")}</li>
                <li>{tPrivacy("texto_privacy.seguridad")}</li>
              </ul>
            </p>

            <p className="mb-0"><span className="fw-bold">{tPrivacy("texto_privacy.inc_b")}</span> {tPrivacy("texto_privacy.parr_inc_b")}</p>
            <p>
              <ul>
                <li>{tPrivacy("texto_privacy.informarle")}</li>
                <li>{tPrivacy("texto_privacy.publicidad")}</li>
                <li>{tPrivacy("texto_privacy.comercial")}</li>
                <li>{tPrivacy("texto_privacy.encuestas")}</li>
              </ul>
            </p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.cinco")}</p>
            <p >{tPrivacy("texto_privacy.parr_cinco")}</p>
            <p>
              <ul>
                <li>
                  <p>{tPrivacy("texto_privacy.servicio")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.empresas")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.aerea")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.gha")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.gsa")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.paqueteria")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.autoridades")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.judiciales")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.sociedades")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.medicos")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.am")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.realizar")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.fusion")}</p>
                </li>
                <li>
                  <p>{tPrivacy("texto_privacy.legal")}</p>
                </li>
              </ul>
            </p>
            <p >{tPrivacy("texto_privacy.lfpd")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.seis")}</p>
            <p >{tPrivacy("texto_privacy.pa_seis")}</p>
            <p >{tPrivacy("texto_privacy.arco")} (<a href="mailto:cadatadospersonales@aeromexico.com">cadatadospersonales@aeromexico.com</a>){tPrivacy("texto_privacy.arco1")}</p>
          
            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.siete")}</p>
            <p >{tPrivacy("texto_privacy.pa_siete")}</p>
            <p >{tPrivacy("texto_privacy.revocar")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.ocho")}</p>
            <p >{tPrivacy("texto_privacy.pa_ocho")}</p>
            <p className="mb-0" >{tPrivacy("texto_privacy.finalidades")}</p>
            <p className="mb-0" >{tPrivacy("texto_privacy.enviar")}</p>
            <p>{tPrivacy("texto_privacy.evitar")} <a href="http://www.rpc.profeco.gob.mx/">www.rpc.profeco.gob.mx</a></p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.nueve")}</p>
            <p >{tPrivacy("texto_privacy.pa_nueve")} <a href="http://amcargo.aeromexico.com">amcargo.aeromexico.com</a>. {tPrivacy("texto_privacy.cookies")}</p>
            <p className="mb-0">{tPrivacy("texto_privacy.datos0")}</p>
            <p>
              <ul>
                <li>{tPrivacy("texto_privacy.tipo")}</li>
                <li>{tPrivacy("texto_privacy.horario")}</li>
                <li>{tPrivacy("texto_privacy.secciones")}</li>
                <li>{tPrivacy("texto_privacy.previo")} <a href="http://amcargo.aeromexico.com">amcargo.aeromexico.com</a>.</li>
                <li>{tPrivacy("texto_privacy.posterior")} <a href="http://amcargo.aeromexico.com">amcargo.aeromexico.com</a>.</li>
                <li>{tPrivacy("texto_privacy.ip")}</li>
              </ul>
            </p>
            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.finalidades1")}</p>
            <ul>
              <li>
                <p>{tPrivacy("texto_privacy.opciones")}</p>
              </li>
              <li>
                <p>{tPrivacy("texto_privacy.web")}</p>
              </li>
            </ul>
            <p>{tPrivacy("texto_privacy.explorer")} <br/><a href="http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies">http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies</a></p>
            <p>{tPrivacy("texto_privacy.firefox")} <br/><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we</a></p>
            <p>{tPrivacy("texto_privacy.chrome")} <br/><a href="http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647">http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647</a></p>
            <p>{tPrivacy("texto_privacy.opera")} <br/><a href="http://help.opera.com/Windows/11.50/es-ES/cookies.html">http://help.opera.com/Windows/11.50/es-ES/cookies.html</a></p>
            <p>{tPrivacy("texto_privacy.safari")} <br/><a href="http://www.apple.com/legal/privacy/es/cookies/">http://www.apple.com/legal/privacy/es/cookies/</a></p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.diez")}</p>
            <p className="mb-0">{tPrivacy("texto_privacy.efectuar")}</p>
            <p className="mb-0">
              <ul>
                <li>{tPrivacy("texto_privacy.anuncios")}</li>
                <li>{tPrivacy("texto_privacy.internet")}</li>
                <li>{tPrivacy("texto_privacy.ultimo")}</li>
              </ul>
            </p>
            <p>{tPrivacy("texto_privacy.relacion")} <a href="http://amcargo.aeromexico.com">amcargo.aeromexico.com</a>. {tPrivacy("texto_privacy.haber")}</p>

            <p className="fw-bold mb-0">{tPrivacy("texto_privacy.once")}</p>
            <p className="mb-0">{tPrivacy("texto_privacy.pa_once")}</p>
            <p>{tPrivacy("texto_privacy.mayor")} <a href="https://home.inai.org.mx/">www.inai.org.mx</a></p>
          </div>
        </div>
      </section>

      <div className="container p-0 ps-3 ps-sm-0 btn-back-container">
        <div className="row">
          <div className="col">
            <Link className="btn-cont-nat" to="/contracts">
              {tPrivacy("privacidad.button")}
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Privacy;